import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {GetParams, GetResponse, Motonave, PostResponse} from '@app/shared';
import {Observable} from 'rxjs';
import {convertGetParamsToHttpParams} from '@app/core';

@Injectable({
  providedIn: 'root'
})
export class MotonaveService {

  motonaveUrl = environment.coreApiBaseUrl + '/api/motonave';

  constructor(private http: HttpClient) { }

  /** Metodos de obtener/crear/actualizar/eliminar Motonave **/
  getMotonave(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.motonaveUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  createMotonave(newMotonave: {name: string, isActive: true}): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.motonaveUrl, newMotonave);
  }

  updateMotonave(Motonave: Motonave): Observable<any> {
    return this.http.put(this.motonaveUrl, Motonave);
  }

  deleteMotonave(MotonavesIds: number[]): Observable<any> {
    return this.http.delete(this.motonaveUrl, {body: {ids: MotonavesIds}});
  }

}
